import { useTranslation } from "react-i18next";

export type TenantConfig = {
  id: string;
  name: string;
  title: string;
  hostname: string;
  supportEmail: string;
  logoHeight: string;
  themeColor: string;
  fonts: {
    display: string;
    sans: string;
  };
};

export const TENANTS: Record<string, TenantConfig> = {
  chlolodesigns: {
    id: "chlolodesigns",
    name: "Chlolo Designs",
    title: "Chlolo Designs – Greeting Cards",
    hostname: "chlolodesigns.com",
    supportEmail: "support@chlolodesigns.com",
    logoHeight: "50px",
    themeColor: "rgb(190, 24, 93)",
    fonts: {
      display: "Inter, system-ui, sans-serif",
      sans: "Inter, system-ui, sans-serif",
    },
  },
  "chlorine.art": {
    id: "chlorine.art",
    name: "Chlorine Fine Art",
    title: "Chlorine Fine Art – Museum-Quality Prints",
    hostname: "chlorine",
    supportEmail: "support@chlorine.co.jp",
    logoHeight: "60px",
    themeColor: "rgb(17, 24, 39)",
    fonts: {
      display: "'Playfair Display', serif",
      sans: "'Inter', sans-serif",
    },
  },
};

/** Static detection helper for use outside React (e.g., API interceptors) */
export function detectTenant(): TenantConfig {
  const hostname = window.location.hostname;
  const params = new URLSearchParams(window.location.search);
  const tenantId = params.get("tenant");
  
  if (tenantId && TENANTS[tenantId]) return TENANTS[tenantId];
  if (hostname.includes("localhost") || hostname.includes("127.0.0.1")) return TENANTS.chlolodesigns;
  
  return Object.values(TENANTS).find((t) => hostname.includes(t.hostname)) || TENANTS.chlolodesigns;
}

/** Hook for use inside React components */
export function useTenant() {
  const { t } = useTranslation();
  const tenant = detectTenant();

  const tTenant = (key: string, params?: any): string => {
    if (tenant.id === "chlorine.art") {
      const chlorineKey = `${key}_chlorine`;
      const translated = t(chlorineKey, params) as string;
      if (translated !== chlorineKey) return translated;
    }
    return t(key, params) as string;
  };

  return { ...tenant, tTenant };
}

// Deprecated: use useTenant() instead for components, or detectTenant() for logic
export const getTenantConfig = detectTenant;
